import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=71b87eb5&scoped=true&lang=html&"
import script from "./CompanyForm.vue?vue&type=script&lang=js&"
export * from "./CompanyForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyForm.vue?vue&type=style&index=0&id=71b87eb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b87eb5",
  null
  
)

export default component.exports